import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

const PageTitle = ({ title }) => (
  <Helmet>
    <title>{title}</title>
  </Helmet>
);

PageTitle.propTypes = {
  title: PropTypes.string,
};

PageTitle.defaultProps = {
  title: null,
};

module.exports = PageTitle;



// WEBPACK FOOTER //
// ./components/misc/PageTitle.js